// extracted by mini-css-extract-plugin
export default {"container":"Orders_container__tYeQB","orders__container":"Orders_orders__container__p2OdT","order":"Orders_order__lPR5u","orders_add":"Orders_orders_add__ShmGL"};